import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

function RelAjusteEstoquePDF(produtos) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR');
  };

  const formatTipoMovimento = (tipo) => {
    switch (tipo) {
      case 3: return 'Entrada';
      case 4: return 'Saída';
      default: return 'Desconhecido';
    }
  };

  const buildTable = (produtosFiltrados, tipoMovimento) => {
    let totalGrupo = 0;
    let totalQtd = 0;

    const body = [
      [
        { text: 'Código', style: 'tableHeader' },
        { text: 'Descrição', style: 'tableHeader' },
        { text: 'Quantidade', style: 'tableHeader' },
        { text: 'Total (R$)', style: 'tableHeader' },
        { text: 'Data', style: 'tableHeader' },
        { text: 'Colaborador', style: 'tableHeader' }
      ]
    ];

    produtosFiltrados.forEach(prod => {
      totalGrupo += prod.TOTAL;
      totalQtd += prod.QTD;

      body.push([
        prod.COD_PRODUTO,
        prod.DESCRICAO,
        prod.QTD,
        prod.TOTAL.toFixed(2),
        formatDate(prod.DATA),
        prod.NOME || '—'
      ]);
    });

    // Linha de total
    body.push([
      { text: 'Total', colSpan: 2, alignment: 'right', bold: true }, {}, 
      { text: totalQtd.toFixed(2), bold: true, alignment: 'center' },
      { text: totalGrupo.toFixed(2), bold: true, alignment: 'center' },
      {}, {}
    ]);

    return [
      { text: `Movimento: ${formatTipoMovimento(tipoMovimento)}`, style: 'subheader', margin: [0, 10, 0, 5] },
      {
        table: {
          headerRows: 1,
          widths: ['auto', '*', 'auto', 'auto', 'auto', '*'],
          body: body
        }
      }
    ];
  };

  const entradas = produtos.filter(p => p.TIPO_MOVIMENTO === 3);
  const saidas = produtos.filter(p => p.TIPO_MOVIMENTO === 4);

  const docDefinition = {
    content: [
      { text: 'Relatório de Ajuste de Estoque', style: 'header' },
      ...buildTable(entradas, 3),
      ...buildTable(saidas, 4)
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'center'
      },
      subheader: {
        fontSize: 14,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        fillColor: '#eeeeee',
        alignment: 'center'
      }
    },
    defaultStyle: {
      fontSize: 10
    },
    pageOrientation: 'landscape'
  };

  pdfMake.createPdf(docDefinition).open();
}

export default RelAjusteEstoquePDF;
